import type { Recommendation } from "@app/analytics/types";

const SAMPLE_RECOMMENDATIONS: Recommendation[] = [
  {
    id: "SAMPLE1FP4T5HA0XYV7JRNFG0Z",
    kind: "participant",
    impact: 8,
    label: "Decline Invite",
    reasons: ["You frequently skip this meeting"],
    actions: [
      {
        kind: "respond_tentative",
        label: "Respond Tentative",
        default: false,
        operationToken: "39120",
      },
      {
        kind: "decline_invite",
        label: "Decline Invite",
        default: true,
        operationToken: "39120",
      },
    ],
    participantUserId: "8",
    subRecommendations: [],
    meetingContext: {
      userId: "1",
      role: "attendee",
      title: "Virtual Happy Hour (Sample)",
      sessionIds: ["1", "2", "3", "4"],
      recurringEventId: "1",
      meetingSchedule: {
        startTime: "2022-09-16T16:00:00-07:00",
        endTime: "2022-09-16T17:00:00-07:00",
        recurrence: ["FREQ=WEEKLY;BYDAY=FR;INTERVAL=1"],
      },
    },
    status: "pending",
  },
  {
    id: "SAMPLE2FP4T5HA0XYV7JRNFG0Z",
    kind: "participant",
    impact: 10,
    label: "Remove Audrey Porter",
    reasons: [
      "Participant has low contribution to discussion",
      "Participant does not appear engaged",
    ],
    actions: [
      {
        kind: "mark_optional",
        label: "Mark Audrey Porter as Optional",
        default: false,
        operationToken: "39120",
      },
      {
        kind: "remove_invitee",
        label: "Remove Audrey Porter",
        default: true,
        operationToken: "39120",
      },
    ],
    subRecommendations: [],
    participantUserId: "7",
    participantName: "Audrey Porter",
    meetingContext: {
      userId: "1",
      role: "calendar_event_creator",
      title: "Product Roadmap Review (Sample)",
      recurringEventId: "2",
      sessionIds: ["5", "6", "7"],
      meetingSchedule: {
        startTime: "2022-09-16T15:00:00-07:00",
        endTime: "2022-09-16T15:30:00-07:00",
        recurrence: ["FREQ=MONTHLY;BYSETPOS=1;BYDAY=MO;INTERVAL=1"],
      },
      inviteeCount: 16,
    },
    status: "pending",
  },
  {
    id: "SAMPLE3FP4T5HA0XYV7JRNFG0Z",
    kind: "participant",
    impact: 10,
    label: "Remove Greg Kenter",
    reasons: [
      "Participant does not appear engaged",
      "Participant arrives late",
      "Participant contributes low sentiment to discussion",
    ],
    actions: [
      {
        kind: "mark_optional",
        label: "Mark Greg Kenter as Optional",
        default: false,
        operationToken: "39120",
      },
      {
        kind: "remove_invitee",
        label: "Remove Greg Kenter",
        default: true,
        operationToken: "39120",
      },
    ],
    participantName: "Greg Kenter",
    participantUserId: "32",
    subRecommendations: [],
    meetingContext: {
      userId: "1",
      role: "calendar_event_creator",
      title: "Product Roadmap Review (Sample)",
      recurringEventId: "2",
      sessionIds: ["5", "6", "7"],
      meetingSchedule: {
        startTime: "2022-09-16T15:00:00-07:00",
        endTime: "2022-09-16T15:30:00-07:00",
        recurrence: ["FREQ=MONTHLY;BYSETPOS=1;BYDAY=MO;INTERVAL=1"],
      },
      inviteeCount: 16,
    },
    status: "pending",
  },
  {
    id: "SAMPLE4FP4T5HA0XYV7JRNFG0Z",
    kind: "participant",
    impact: 2,
    label: "Review Anika Geldt",
    reasons: ["Participant has low overall sentiment"],
    actions: [
      {
        kind: "acknowledge",
        label: "Review Anika Geldt",
        default: true,
        operationToken: "39120",
      },
    ],
    subRecommendations: [],
    participantName: "Anika Geldt",
    participantUserId: "321",
    meetingContext: {
      userId: "1",
      role: "calendar_event_creator",
      title: "Product Roadmap Review (Sample)",
      recurringEventId: "2",
      sessionIds: ["5", "6", "7"],
      meetingSchedule: {
        startTime: "2022-09-16T15:00:00-07:00",
        endTime: "2022-09-16T15:30:00-07:00",
        recurrence: ["FREQ=MONTHLY;BYSETPOS=1;BYDAY=MO;INTERVAL=1"],
      },
      inviteeCount: 16,
    },
    status: "pending",
  },
  {
    id: "SAMPLE5FP4T5HA0XYV7JRNFG0Z",
    kind: "meeting",
    label: "Delete Meeting Series",
    impact: 11,
    reasons: [
      "Low attendance rate",
      "Low degree of interactions between participants",
      "Participants are not engaged",
    ],
    actions: [
      {
        kind: "delete_event",
        label: "Delete Meeting Series",
        default: true,
        operationToken: "39120",
      },
    ],
    subRecommendations: [],
    meetingContext: {
      userId: "1",
      role: "calendar_event_creator",
      title: "Book Club (Sample)",
      recurringEventId: "3",
      sessionIds: ["12", "13", "14", "15"],
      meetingSchedule: {
        startTime: "2022-09-16T09:00:00-07:00",
        endTime: "2022-09-16T10:00:00-07:00",
        recurrence: ["FREQ=WEEKLY;BYDAY=TU;INTERVAL=1"],
      },
      inviteeCount: 8,
    },
    status: "pending",
  },
  {
    id: "SAMPLE6FP4T5HA0XYV7JRNFG0Z",
    kind: "participant",
    label: "Review Your Attendance",
    impact: 0,
    reasons: ["You arrived late", "You did not appear engaged"],
    actions: [
      {
        kind: "acknowledge",
        label: "Review Your Attendance",
        default: true,
        operationToken: "39120",
      },
    ],
    participantUserId: "1",
    subRecommendations: [],
    meetingContext: {
      userId: "1",
      role: "attendee",
      title: "1:1 Manager Sync (Sample)",
      sessionIds: ["16"],
      meetingSchedule: {
        startTime: "2022-09-08T10:00:00-07:00",
        endTime: "2022-09-08T10:30:00-07:00",
      },
      inviteeCount: 2,
    },
    status: "pending",
  },
];

export default SAMPLE_RECOMMENDATIONS;
